// Config for the native in-app browser (@capacitor/browser). On iOS this is
// SFSafariViewController, on Android a Chrome Custom Tab — both ship their own
// chrome with back, share and "open in Safari/Chrome", so we add no UI of our
// own. No magic numbers/strings live in the feature code; everything tunable
// sits here.

// Only these schemes are ours to intercept. Everything else (mailto:, tel:,
// rubra:, intent:) must reach the OS untouched.
export const EXTERNAL_LINK_PROTOCOLS = ['http:', 'https:']

// Theme colour token used to tint the browser toolbar, resolved against the
// ACTIVE Vuetify theme at open time so light and dark both work from one
// constant. The app defines no brand `surface` key — neutral0 is the real
// card/bar surface (see src/styles/variables.scss).
export const TOOLBAR_COLOR_TOKEN = 'neutral0'

// Non-native fallback, and the deliberate "escape to the system browser" path:
// unchanged from the pre-in-app-browser behaviour.
export const WEB_LINK_TARGET = '_blank'
export const WEB_LINK_FEATURES = 'noopener'

// Click-interception DOM details.
export const LINK_SELECTOR = 'a[href]'
// A `download` anchor saves a file rather than navigating, so leave it alone.
export const DOWNLOAD_ATTRIBUTE = 'download'
